import React, { useState} from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { DayOfWeek } from '../constants/index';
import 'react-datepicker/dist/react-datepicker.css';

const EditBusinessHourModal = ({ isOpen, toggle, onSave, timeframes, businessHours, onInputChange }) => {
    const [selectedTimeframe, setSelectedTimeframe] = useState(businessHours ? businessHours.timeframe : '');
    
    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader toggle={toggle}>Update Business Hours</ModalHeader>
            <ModalBody>
                <Form onSubmit={(e) => { e.preventDefault(); onSave(businessHours); }}>
                    <FormGroup>
                        <Label for="timeframe">Timeframe</Label>
                        <Input type="select" name="timeframe" id="timeframe" value={selectedTimeframe} onChange={(e) => setSelectedTimeframe(e.target.value)}>
                            {timeframes.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="day_of_week">Day of Week</Label>
                        <Input type="select"
                            id="day_of_week"
                            name="day_of_week"
                            value={businessHours.day_of_week}
                            onChange={(e) => onInputChange('day_of_week', e.target.value)}
                        >
                            {Object.keys(DayOfWeek).map((key, index) => (
                                <option key={index} value={index}>{DayOfWeek[key]}</option>
                            ))}
                        </Input>
                    </FormGroup>

                    <FormGroup>
                        <Label for="start_time">Start Time</Label>
                        <Input
                            type="time"
                            id="start_time"
                            name="start_time"
                            value={businessHours.start_time}
                            onChange={(e) => onInputChange('start_time', e.target.value)}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Label for="end_time">End Time</Label>
                        <Input
                            type="time"
                            id="end_time"
                            name="end_time"
                            value={businessHours.end_time}
                            onChange={(e) => onInputChange('end_time', e.target.value)}
                        />
                    </FormGroup>

                    <Button color="primary" type="submit">Save</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditBusinessHourModal;